import { Flex } from 'antd';
import { Responsive, WidthProvider } from 'react-grid-layout';

import { DashboardTitle } from './components/DashboardTitle';
import { WIDGETS } from './constants';
import { LoadingWrapper, Wrapper } from './styles';

import { InfoBanner } from '@/components/InfoBanner';
import { InfoTestTeacherBanner } from '@/components/InfoTestTeacherBanner';
import { LoadingCircleSpinner } from '@/components/Loaders';
import { PagePaddingContainer } from '@/components/PagePaddingContainer';
import { useTagFeatures } from '@/hooks';
import { useTestBannerInfo } from '@/hooks/useTestBannerInfo';
import { useProfile } from '@/store';

import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';

const ResponsiveGridLayout = WidthProvider(Responsive);

const ROW_HEIGHT = 285;

export const DashboardPage = () => {
  const { profile, roleCheck } = useProfile();
  const { isLoading, canRender } = useTagFeatures();
  const { isInfoTestBannerOpen, toggleInfoTestBanner } = useTestBannerInfo();

  if (!profile || isLoading)
    return (
      <PagePaddingContainer>
        <LoadingWrapper>
          <LoadingCircleSpinner />
        </LoadingWrapper>
      </PagePaddingContainer>
    );

  const { role } = profile;
  const widgets = WIDGETS[role];
  const { isAdmin, isManager, isTeacher } = roleCheck;

  const isEditable = isAdmin || isManager;

  const layouts = {
    lg: widgets.map(({ position }, i) => {
      const { x, y, w, h } = position;
      return {
        i: i.toString(),
        x,
        y,
        w,
        h,
        minH: h,
        minW: w
      };
    })
  };

  return (
    <PagePaddingContainer>
      <Wrapper>
        {!isManager && isInfoTestBannerOpen && (
          <InfoBanner onClose={toggleInfoTestBanner}>
            {isTeacher && <InfoTestTeacherBanner />}
          </InfoBanner>
        )}
        <DashboardTitle />
        <ResponsiveGridLayout
          className="layout"
          style={{ margin: '0 auto' }}
          layouts={layouts}
          isDraggable={false}
          isResizable={false}
          rowHeight={ROW_HEIGHT}
          cols={{ lg: 12, md: 12, sm: 1, xs: 1, xxs: 1 }}
          breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
          containerPadding={[0, 0]}
          margin={[16, 16]}>
          {widgets.map(
            ({ Widget, availableForFeature }, i) =>
              canRender(availableForFeature) && (
                <Flex key={i}>
                  <Widget editable={isEditable} />
                </Flex>
              )
          )}
        </ResponsiveGridLayout>
      </Wrapper>
    </PagePaddingContainer>
  );
};
